<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/uams/apps')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					开发中心 <v-spacer />
				</v-card-title>
				<v-toolbar flat color="rgba(0,0,0,0)">
					<v-btn-toggle v-model="btnValue" color="primary" mandatory dense group class="ml-n2">
						<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index" :to="item.url">{{ item.val }}</v-btn>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<div style="width: 300px">
						<v-text-field @click:append="searchQuery" @keyup.enter="searchQuery" v-model="queryParam.condition" placeholder="目录名称 / 服务编码" class="pt-5" append-icon="mdi-magnify" outlined dense clearable></v-text-field>
					</div>
				</v-toolbar>
				<v-card-text class="pt-0">
					<v-data-table :headers="headers" :items="desserts" disable-pagination :loading="loading" loading-text="数据加载中..." class="elevation-0" hide-default-footer>
						<template v-slot:[`item.projName`]="{ item }">
							<v-img :src="item.projIcon" width="72" height="72" class="d-inline-block mr-2"></v-img>
							<div class="py-3 d-inline-block" style="width: calc(100% - 100px)">
								<span :title="item.projName" class="body-1 font-weight-bold">
									{{ item.projName }}
									<v-chip v-for="e in item.projXtsd.split(',')" :key="e" class="ml-1" :class="e | dict('1:green lighten-5  green--text/2:orange lighten-5  orange--text/3:blue lighten-5  blue--text')" small label>
										{{ e | dict("1:治理端/2:服务端/3:协同端") }}
									</v-chip>
								</span>
								<v-row class="py-2" style="color: #979797c2">
									<v-col style="max-width: 300px">业务类别：{{ item.bizName }}</v-col>
									<v-col>服务编码：{{ item.projCode }}</v-col>
								</v-row>
								<span :title="item.name" class="d-block" style="color: #979797c2">介绍：{{ item.projNote }}</span>
							</div>
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<a class="font-weight-bold mr-4 primary--text" @click="edit(item)">编辑</a>
						</template>
					</v-data-table>
					<v-divider />
					<pagination class="my-4 mr-2 float-right" :page-sizes="[10, 10, 20]" :page-data="pageData" @pageChange="getListPage" />
				</v-card-text>
			</v-card>
		</div>

		<!----------------------- 编辑服务目录弹窗 ----------------------->
		<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="600px">
			<v-card elevation="0">
				<v-card-title>
					服务目录编辑
					<v-spacer />
					<v-btn @click="close" icon><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider class="grey lighten-2" />
				<v-card-text class="px-0"> </v-card-text>
				<v-card-actions class="mx-auto my-2">
					<v-spacer />
					<v-btn color="info" elevation="0"><v-icon class="mr-2">mdi-checkbox-marked-circle-outline</v-icon> 提交 </v-btn>
					<v-btn @click="close" class="ml-2" elevation="0"><v-icon class="mr-2">mdi-undo-variant</v-icon> 取消 </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
import PageMixins from "@/compositions/mixins/pagination";
import Pagination from "@/components/pagination";
export default {
	mixins: [PageMixins],
	components: { Pagination },
	data: () => ({
		loading: true,
		url: { list: "/app/abiz/page" },
		headers: [
			{ text: "目录", value: "projName", sortable: false },
			// { text: "操作", value: "actions", sortable: false, width: 100 },
		],
		btnGroup: [
			{ key: "1", val: "开发单位", url: "/uams/apps-acid" },
			{ key: "2", val: "开发文档", url: "/uams/apps-docu" },
			{ key: "3", val: "服务接口", url: "/uams/apps-apis" },
			{ key: "0", val: "服务目录", url: "/uams/apps-abiz" },
		],
		btnValue: "0",
		dialog: false,
	}),
	mounted() {
		this.loadData();
	},
	methods: {
		//编辑
		edit() {
			this.dialog = true;
		},
		//关闭弹窗
		close() {
			this.dialog = false;
		},
	},
};
</script>
<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table th {
	background: rgba(204, 204, 204, 0.215);
}
</style>
